import { render, staticRenderFns } from "./CarrierTaxFormModal.vue?vue&type=template&id=0f73949e&scoped=true&"
import script from "./CarrierTaxFormModal.vue?vue&type=script&lang=js&"
export * from "./CarrierTaxFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f73949e",
  null
  
)

export default component.exports